module.exports = __webpack_public_path__ + "static/img/logo_1.9a93ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/logo_1.png
// module id = nq1F
// module chunks = 1